import { render, staticRenderFns } from "./IsSupplierContact.vue?vue&type=template&id=c4b009fc&"
import script from "./IsSupplierContact.vue?vue&type=script&lang=js&"
export * from "./IsSupplierContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports